import React, { useMemo, useRef } from 'react';
import { TorpedoItem, TorpedoLayoutedItem } from '../../types';
import useDuperbrowseScrollRestoration from '../../../Duperbrowse/hooks/useDuperbrowseScrollRestoration';
import RowWrapper from './RowWrapper';

export interface Props {
  items: TorpedoLayoutedItem<TorpedoItem>[];
  width: number;
  height: number;
  extraItemHeight?: number;
}

const HiddenRow: React.FC<Props> = ({
  items,
  width,
  height,
  extraItemHeight = 0,
}) => {
  const itemIds = useMemo(
    () => items.map(item => item.dto.duperbrowseItemId!),
    [items]
  );
  const rowRef = useRef<HTMLDivElement>(null);
  useDuperbrowseScrollRestoration(itemIds, rowRef);

  return (
    <RowWrapper
      style={{
        width: width,
        height: height + extraItemHeight,
      }}
      ref={rowRef}
    />
  );
};
HiddenRow.displayName = 'HiddenRow';

export default React.memo(HiddenRow);
